<template>
  <el-row :gutter="15" >
    <el-col v-for=" (item,index) in progressContent" :span="3" :key="index" class="progre"  >
      <div class="progre-title">
        <div style="margin:8px 0px;" >
          <div class="item-name" @click="route(item)" :title="item.name">{{item.name}}</div>
          <!-- v-if 任务取消 则不显示完成率-->
          <!-- <div style="width:25%;float: right;font-weight:600" :style="{color:statusColor[item.color-1].color}" v-if="item.color != 4">{{item.percentComplete +'%'}}</div> -->
          <div style="width:25%;float: right;font-weight:600" :style="{color:statusColor[item.color-1].color}">{{item.percentComplete +'%'}}</div>
        </div>
        <!-- <LineProgress :text-inside="true" :percentage='item.phaPercentComplete' :bgStatus='item.bgStatus' :stroke-width="12"></LineProgress> -->
        <el-progress  style="width:100%; float: left;margin-top:6px" class="item" :text-inside='true' :percentage='item.percentComplete' :color="statusColor[item.color-1].color"  :stroke-width="8"></el-progress>
        <!-- <el-progress  style="width:100%; float: left;margin-top:6px" :percentage='item.percent' :color="item.status"  :stroke-width="12"></el-progress> -->
      </div>      
    </el-col>
  </el-row>
</template>

<script>
export default {
  data(){
    return{
      statusColor:[
        {id:1,color: '#13ce66',name:'正常阶段'},
        {id:2,color: '#fcad2c',name:'需要注意'},
        {id:3,color: '#F56C6C',name:'延迟阶段'},
        {id:4,color: '#38a8f6',name:'暂停任务'},
        {id:5,color: '#999',name:'取消任务'}
      ]
    }
  },
  props:['progressContent'],
  // computed:{
  //   getStatusColor(){
  //     console.log(this.progressContent);
  //   }
  // },
  // watch:{
  //   getStatusColor(){
  //     console.log(this.progressContent);
  //   }
  // },
  methods:{
    route(e){
      this.$emit('clickLink',e)
    }
  }
}
</script>

<style >
.item .el-progress-bar__innerText {
  display: none;
}
</style>
<style scoped>
.progre{
  margin-left:8px ;
  border-radius: 3px;
  background-color: #fff;
  height: 70px;
  margin: 5px;
  padding: 5px;
  border-left: #4b91ff 4px solid;
  border-bottom: 1px solid #dcdcdc;
}
  .progre-title{
    font-size: 14px;
    text-align: left;
    white-space: nowrap; 
    overflow: hidden;
    text-overflow: ellipsis;
  }
  .progre-title p{
    height: 14px;
    line-height: 14px;
    margin: 4px 0;
    overflow: hidden; 
    text-overflow: ellipsis   
  }
  .progre-title p:hover{
    color: #4b91ff;
    text-decoration: underline;
    cursor: pointer;
  }
  .item-name{
    font-size: 14px;
    width:60%;
    float:left;
    text-overflow:ellipsis;
    overflow: hidden;
    cursor: pointer;
  }
  .item-name:hover{
    color: #4b91ff;
    text-decoration: underline;
  }
</style>